import { Modal } from '@mantine/core'
import React from 'react'
import ModalHeader from './ModalHeader'
import { IconXboxX } from '@tabler/icons-react';

type MantineModalProps = {
    open: boolean
    done: () => void
    title: string
    children: any
}

export default function MantineModal({ open, done, title, children }: MantineModalProps) {
    return (
        <Modal
            opened={open}
            onClose={() => done()}
            radius="lg"
            size="lg"
            centered
            title={<ModalHeader title={title} />}
            closeButtonProps={{
                icon: <IconXboxX size={20} stroke={1.5} />,
            }}
            styles={{
                header: {
                    backgroundColor: '#228be6',
                    color: 'white',
                },
            }}

        >
            {children}
        </Modal>
    )
}
